import axios from "../utils/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getUserSubscription = createAsyncThunk(
  "subscription/user",
  async () => {
    try {
      const response = await axios.get("subscription/user");
      return response?.data;
    } catch (error) {
      return error;
    }
  }
);

export const cancelSubscription = createAsyncThunk(
  "subscription/cancelSubscription",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("subscription/cancelSubscription", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getSubscriptionPlans = createAsyncThunk(
  "subscription/products",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.get("subscription/products");
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const checkout = createAsyncThunk(
  "subscription/createCheckoutSession",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("subscription/createCheckoutSession", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

// Add subscription upgrade/downgrade service
export const upgradeSubscription = createAsyncThunk(
  "subscription/upgrade",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("subscription/upgrade", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);
export const renewSubscription = createAsyncThunk(
  "subscription/renewedSubscription",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("subscription/renewedSubscription", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const renewSubscriptionFromReminder = createAsyncThunk(
  "subscription/reminderRenewal",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("subscription/reminder-renewal", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Add immediate subscription refresh after successful payment
export const refreshSubscriptionStatus = createAsyncThunk(
  "subscription/refreshStatus",
  async (payload, thunkAPI) => {
    try {
      // Wait a moment for backend processing
      await new Promise(resolve => setTimeout(resolve, 2000));
      const response = await axios.get("subscription/user");
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const retrieveSession = createAsyncThunk(
  "subscription/retrieve",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("subscription/retrieve", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

// Admin dashboard: high-level stats
export const getDashboardStats = createAsyncThunk(
  "admin/stats",
  async (payload = {}, thunkAPI) => {
    try {
      const params = new URLSearchParams();
      // Map UI terms to backend expected terms
      const map = {
        today: "day",
        daily: "day",
        day: "day",
        weekly: "week",
        week: "week",
        monthly: "month",
        month: "month",
        yearly: "year",
        year: "year",
      };
      if (payload?.timeframe) {
        const tf = map[payload.timeframe] || payload.timeframe;
        params.append("timeframe", tf);
      }
      // Cache buster to avoid stale 304s when switching timeframe
      params.append("_", Date.now().toString());
      const qs = params.toString();
      // Some backends serve this under /admin/stats
      const url = `admin/stats${qs ? `?${qs}` : ""}`;
      const response = await axios.get(url);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

// Subscription analytics: non-renewed
export const getNonRenewedSubscription = createAsyncThunk(
  "subscription/nonRenewed",
  async (payload = {}, thunkAPI) => {
    try {
      const params = new URLSearchParams();
      if (payload?.timeframe) params.append("timeframe", payload.timeframe);
      const qs = params.toString();
      const url = `subscription/non-renewedSubscription${qs ? `?${qs}` : ""}`;
      const response = await axios.get(url);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

// Subscription analytics: upcoming renewals
export const getUpcomingRenewals = createAsyncThunk(
  "subscription/upcomingRenewals",
  async (payload = {}, thunkAPI) => {
    try {
      const params = new URLSearchParams();
      if (payload?.timeframe) params.append("timeframe", payload.timeframe);
      // Prevent stale 304 responses that can lead to empty bodies client-side.
      params.append("_", Date.now().toString());
      const qs = params.toString();
      const url = `subscription/upcoming-renewals${qs ? `?${qs}` : ""}`;
      const response = await axios.get(url, {
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      });
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);
